import React from 'react';
import { useLanguage } from './LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-white pt-24 pb-12 overflow-hidden" data-id="element-84">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        {/* Massive Logo Text */}
        <div className="flex justify-center mb-16" data-id="element-86">
          <span className="font-heading font-black text-[18vw] leading-none tracking-tighter select-none bg-gradient-to-r from-[#2B7A8F]/10 via-[#30BBA8]/10 to-[#5CD4C2]/10 bg-clip-text text-transparent" data-id="element-87">
            BODY • ON
          </span>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-8 border-t border-gray-100 pt-8" data-id="element-88">
          <div className="flex items-center gap-4" data-id="element-89">
            <div className="flex items-center grayscale opacity-40 hover:grayscale-0 hover:opacity-100 transition-all duration-300 cursor-pointer" data-id="element-90">
              <img src="https://cdn.magicpatterns.com/uploads/ppUnKnYhBKTX8zx2E76sSP/ISO_ERGOCENTER_1.svg" alt="Body•On Logo" className="h-6 w-6 object-contain" data-id="element-91" />
              <span className="font-heading font-bold text-xl tracking-wide ml-2 bg-gradient-to-r from-[#2B7A8F] via-[#30BBA8] to-[#5CD4C2] bg-clip-text text-transparent" data-id="element-92">
                Body • On
              </span>
            </div>
            <span className="text-sm text-gray-400 font-light ml-2" data-id="element-93">
              © {new Date().getFullYear()} Body•On. {t('footer.rights')}
            </span>
          </div>

          <div className="flex flex-wrap justify-center gap-8 text-sm font-medium text-gray-500 uppercase tracking-widest" data-id="element-94">
            <a href="#servicios" className="hover:text-bodyon-teal transition-colors" data-id="element-95">
              {t('nav.services')}
            </a>
            <a href="#nosotros" className="hover:text-bodyon-teal transition-colors" data-id="element-96">
              {t('nav.about')}
            </a>
            <a href="#ubicaciones" className="hover:text-bodyon-teal transition-colors" data-id="element-97">
              {t('nav.locations')}
            </a>
            <a href="#contacto" className="hover:text-bodyon-teal transition-colors" data-id="element-98">
              {t('nav.contact')}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}